import { render } from "./ViewEvent.vue?vue&type=template&id=b9ac87dc&scoped=true"
import script from "./ViewEvent.vue?vue&type=script&lang=js"
export * from "./ViewEvent.vue?vue&type=script&lang=js"

import "./ViewEvent.vue?vue&type=style&index=0&id=b9ac87dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ac87dc"]])

export default __exports__